import styled from 'styled-components';

export const Rect = styled.rect`
  color: ${({ theme }) => theme.colors.accent};
`;
